import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { DecisionWatcherButton } from './DecisionWatcherButton';
import { PrimaryButton } from '../../../components/button';
import { CancelWatcherCreationButton } from '../../../watchers/components/cancel-watcher-creation/CancelWatcherCreationButton';

export const SearchDecisionWatcher: FC = () => (
  <DecisionWatcherButton source="create_search_watcher">
    {({
      createWatcher,
      isWatched,
      deleteWatcher,
    }: {
      createWatcher: () => void;
      isWatched: boolean;
      deleteWatcher: () => void;
    }) => (
      <div className="decision-watcher-button">
        {!isWatched && (
          <PrimaryButton
            iconLeft="notifications_none"
            dataName="add-decision-watcher"
            onClick={createWatcher}
          >
            <FormattedMessage id="app.pages.search.addWatcher" />
          </PrimaryButton>
        )}
        {isWatched && (
          <CancelWatcherCreationButton
            deleteWatcher={deleteWatcher}
            tooltipId="search-decision-watcher-button"
          />
        )}
      </div>
    )}
  </DecisionWatcherButton>
);
